<template>
    <el-dialog title="查询结果" :visible.sync="dialogVisible" width="680px">
        <div class="con">
            <div class="con-top">
                <p class="title">司法链核验报告</p>
                <div class="flex_both align-end">
                    <div class="con-p flex-1">
                        <p>文件名称：</p>
                        <span>{{ resultInfo.name || '-' }}</span>
                    </div>
                    <img v-if="resultStampSrc" :src="resultStampSrc" width="120" height="110" alt="" />
                </div>
                <div class="con-p" v-if="resultInfo.type == 'tongguo'">
                    <p>文件Hash：</p>
                    <span>{{ resultInfo.hash || '-' }}</span>
                </div>
                <div class="con-p" v-if="resultInfo.type == 'tongguo'">
                    <p>检验结果：</p>
                    <div class="flex-c">
                        <div class="con-div">
                            <img src="@/assets/img/check/dui.png" width="20" style="margin: 7px 6px 0 0;" />
                            <span style="color: #109034">检测通过</span>
                        </div>
                        <div class="con-div">
                            <div class="block"></div>
                            <span>比对结果一致</span>
                        </div>
                        <div class="con-div">
                            <div class="block"></div>
                            <span>文件已在司法区块链存证</span>
                        </div>
                        <div class="con-div">
                            <div class="block"></div>
                            <span>文件完整性校验通过，数据<br />未被篡改</span>
                        </div>
                    </div>
                </div>
                <div class="con-p" v-else>
                    <p>检验结果：</p>
                    <div class="flex-c">
                        <div class="con-div">
                            <img src="@/assets/img/check/cuo.png" width="20" height="20" style="margin: 7px 6px 0 0;" />
                            <span>核验失败</span>
                        </div>
                        <span style="display: block;width: 13em;padding-left: 26px;">该文件尚未在司法区块链存证，或与链上存证数据不一致！</span>
                    </div>
                </div>
                <div class="con-p" v-if="resultInfo.type == 'tongguo'">
                    <p>存证时间：</p>
                    <span>{{ resultInfo.czsj || '-' }}</span>
                </div>
                <div class="con-p" v-else>
                    <p>核验时间：</p>
                    <span>{{ formattedDateTime || '-' }}</span>
                </div>
                <div class="con-p" v-if="resultInfo.type == 'tongguo'">
                    <p>存证类型：</p>
                    <span>文本存证</span>
                </div>
                <div class="con-p" v-else>
                    <p class="flex_10">无法通过核验原因：</p>
                    <div class="flex-c">
                        <div class="flex">
                            <img src="@/assets/img/check/wenjian.png" width="20" height="20" class="mr-8" />
                            <span>文件尚未上链存证</span>
                        </div>
                        <div class="flex">
                            <img src="@/assets/img/check/wenjian.png" width="20" height="20" class="mr-8" />
                            <span>文件内容被篡改</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="con-foot flex_center">
                <div class="flex">
                    <img src="@/assets/img/check/info.png" width="24" height="24" />
                    <p>本核验报告由上海法院诉讼服务平台提供</p>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: ['resultInfo'],
    data() {
        return {
            dialogVisible: false
        };
    },
    methods: {
        open(val) {
            console.log(val)
            this.dialogVisible = true
        },
    },
    computed: {
        /** 动态路径不能写 `@/` 字符串，需 require 才能被打包解析 */
        resultStampSrc() {
            const type = this.resultInfo && this.resultInfo.type
            if (!type)
                return ''
            try {
                return require(`@/assets/img/check/${type}.png`)
            }
            catch (e) {
                return ''
            }
        },
        // 获取当前日期时间
        currentDateTime() {
            return new Date();
        },
        // 格式化日期时间
        formattedDateTime() {
            const date = this.currentDateTime;
            return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
        }
    }
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
    padding: 0 20px 0;
}

.con {
    width: 100%;
    min-height: 800px;
    background: url('../../assets/img/check/bg.jpg') no-repeat 0 center;
    background-size: 100% 100%;
    padding: 140px 70px 120px;
    font-size: 20px;
    color: #333;
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    // 公用样式
    .align-end {
        align-items: flex-end
    }

    .flex-1 {
        flex: 1
    }

    .flex-c {
        display: flex;
        flex-direction: column
    }

    .mr-8 {
        margin-right: 8px
    }

    // end

    .con-top {
        margin-bottom: 30px;
    }

    .title {
        font-size: 32px;
        color: #064cbb;
        font-weight: 500;
        text-align: center;
        letter-spacing: 3px;
    }

    .con-p {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 10px;


        .con-div {
            display: flex;
            align-items: flex-start;
        }

        .block {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #109034;
            margin: 11px 10px 0 5px;
        }

        p {
            flex: 0 0 6em;
            font-weight: 500;
        }

        .flex_10 {
            flex: 0 0 10em;
        }

        span {
            display: block;
            flex: 1;
            color: #666666;
        }
    }

    .con-foot {
        img {
            margin-right: 10px;
        }

        p {
            font-size: 18px;
            color: #666;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/check/result.vue